import DocumentationPage from '@/modules/quant/documentation/documentation-page';
import { requireCapability } from '@/utils/route-guards';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const searchSchema = z.object({
  chapter: z.string().optional(),
});

export const Route = createFileRoute('/_dashboard/dashboard/quant/documentation/')({
  beforeLoad: () => requireCapability('quantLab'),
  component: RouteComponent,
  validateSearch: (search) => searchSchema.parse(search),
});

function RouteComponent(): JSX.Element {
  const { chapter } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <DocumentationPage
      chapter={chapter}
      onChapterChange={(id) => void navigate({ search: { chapter: id } })}
    />
  );
}
